import client from '@/services/';

const state = () => ({
    all: [],
    one: {},
    fichier: [],
    uploadedFile: null,
});

const getters = {
    all: state => state.all,
    one: state => state.one,
    fichier: state => state.fichier,
    uploadedFile: state => state.uploadedFile,

};

const mutations = {
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
    SET_ONE: (state, obj) => {
        state.one = obj;
    }, 
    SET_FICHIER: (state, obj) => {
        state.fichier = obj;
    },
    SET_UPLOADED_FILE: (state, obj) => {
        state.uploadedFile = obj;
    },
}

const actions = {
    async uploadFichier({ commit }, { typeId, payload }) {
        try {
          const data  = await client.post(`fichier/add/${typeId}`, payload, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
          commit('SET_FICHIER', data);
          return data;
      
        } catch (error) {
            console.error('Erreur lors de l\'ajout du document :', error);
          throw error;
        }
    },
    async downloadFichier({ commit }, { fichierId }) {
        try {
            const response = await client.get(`fichier/download/${fichierId}`, {
                responseType: 'blob' // Spécifier que la réponse doit être traitée comme un blob (fichier binaire)
            });
            
            const fileUrl = URL.createObjectURL(response.data); // Convertir le blob en URL
            commit('SET_UPLOADED_FILE', fileUrl);
    
            return fileUrl;
        } catch (error) {
            console.error('Erreur lors du téléchargement du fichier:', error);
            throw error; 
        }
    }
    
    
    
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};